import { useState, useEffect } from "react";
import { RefreshCw } from "lucide-react";
import { useI18n } from "@/lib/i18n";

export default function UpdateNotification() {
  const [showUpdate, setShowUpdate] = useState(false);
  const { t } = useI18n();

  useEffect(() => {
    if (!("serviceWorker" in navigator)) return;

    navigator.serviceWorker.ready.then((registration) => {
      if (registration.waiting) {
        setShowUpdate(true);
      }

      registration.addEventListener("updatefound", () => {
        const newSW = registration.installing;
        if (!newSW) return;
        newSW.addEventListener("statechange", () => {
          if (newSW.state === "installed" && navigator.serviceWorker.controller) {
            setShowUpdate(true);
          }
        });
      });
    });

    let refreshing = false;
    navigator.serviceWorker.addEventListener("controllerchange", () => {
      if (refreshing) return;
      refreshing = true;
      window.location.reload();
    });
  }, []);

  const handleUpdate = () => {
    navigator.serviceWorker.ready.then((registration) => {
      if (registration.waiting) {
        registration.waiting.postMessage({ type: "SKIP_WAITING" });
      }
    });
  };

  if (!showUpdate) return null;

  return (
    <div className="fixed bottom-20 left-1/2 -translate-x-1/2 z-[100] animate-slide-up">
      <button
        onClick={handleUpdate}
        className="flex items-center gap-2 px-4 py-2.5 bg-cyan-500/10 border border-cyan-500/30 rounded-full text-cyan-400 text-sm font-mono backdrop-blur-md hover:bg-cyan-500/20 transition-colors"
      >
        <RefreshCw className="w-4 h-4" />
        {t.updateAvailable}
      </button>
    </div>
  );
}
